import styled from 'styled-components';

import { size } from '../layout/helpers';
import { theme } from '../layout/theme';

export const Graphic = styled.img`
  margin-bottom: ${size(0.5)};
  max-width: 100%;

  &.extra-distance {
    margin-bottom: ${size(1)};
  }

  &:not(.no-max-height) {
    max-height: 60px;
  }

  ${theme.screens.XS} {
    &:not(.no-max-height) {
      max-height: 70px;
    }

    &.extra-distance {
      margin-bottom: ${size(2)};
    }
  }

  ${theme.screens.Md} {
    margin-bottom: ${size(1)};

    &:not(.no-max-height) {
      max-height: 140px;
    }

    &.extra-distance {
      margin-bottom: ${size(4)};
    }
  }
`;
